import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiBankTransactionsList } from 'Services/StoreUserService'
import { getFinancialYearDates } from 'Utils/helper'

export const getData = createAsyncThunk('storeUser/bankTransactions/getData', async datas => {
    const { data } = await apiBankTransactionsList(datas)
    return data
})

export const getView = createAsyncThunk('storeUser/bankTransactions/getView', async id => {
    return viewData
})

const viewData = {
    bank_account_id: '',
    expense_id: '',
    amount: '',
    description: '',
    type: '',
}

export const bankTransactionsSlice = createSlice({
    name: 'storeUser/bankTransactions',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            ...getFinancialYearDates(),
            bank_account_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
        setBankAccount: (state, { payload }) => {
            state.table.page = 1
            state.table.bank_account_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate, setBankAccount } = bankTransactionsSlice.actions

export default bankTransactionsSlice.reducer
